import React from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import styles from './PriceTooltip.css';
import Tooltip from 'components/Tooltip';
import InfoIcon from 'images/info-basic.svg';
import PriceRow from 'components/OfferPriceRow/OfferPriceRow';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { PriceType } from '@rome/response/enums/PriceType';
import PriceDescription from 'widgets/ProductPageSummary/PriceTooltip/PriceDescription';
export default function PriceTooltip(props) {
    const { pricing, containerClass } = props;
    if (!pricing || !pricing.value)
        return null;
    const { prices, mrp, finalSavingsText, extraDiscount, priceDescriptions } = pricing.value;
    const priceDescription = priceDescriptions && priceDescriptions[0];
    const pricesLength = prices ? prices.length : 0;
    const finalPrice = pricesLength > 0 ? prices[pricesLength - 1] : null;
    const partPrices = get(pricing, ['value', 'partPriceInfo', 'partPrices']);
    return (<div className={cx(styles['info-container'], containerClass)}>
			<img className={styles['info-icon']} src={InfoIcon} id="price-info-icon"/>

			<Tooltip anchor="#price-info-icon" theme="light" className={styles['offer-tooltip-container']} position="bottom">
				<div className={styles['offer-tooltip']}>
					<div className={styles['tooltip-title']}>{stringTemplate('priceSummaryHeader')}</div>
					{pricesLength !== 0 || mrp ? (<div className={styles['price-details']}>
							{mrp && (<PriceRow isDecimal subText={mrp.additionalText} text={mrp.name} value={mrp.decimalValue} valueClassName={mrp.strikeOff ? styles['strike-off'] : ''}/>)}

							{prices.map((price, key) => key < pricesLength - 1 ? (<PriceRow isDecimal subText={price.additionalText} key={key} text={price.name} value={price.decimalValue} valueClassName={price.strikeOff ? styles['strike-off'] : ''}/>) : null)}

							{extraDiscount && extraDiscount.priceType === PriceType.EXTRA_DISCOUNT ? (<PriceRow isDecimal subText={extraDiscount.additionalText} text={extraDiscount.name} value={extraDiscount.decimalValue} valueClassName={styles['special-value']}/>) : null}

							{finalPrice ? (<div className={styles['price-total']}>
									<PriceRow isDecimal text={finalPrice.name} value={finalPrice.decimalValue} textClassName={styles['total']} valueClassName={styles['total']}/>
								</div>) : null}
							{partPrices && (<div className={styles['pre-order']}>
									{partPrices.map(partPrice => (<PriceRow isDecimal text={partPrice.secondaryText} value={partPrice.price} textClassName={styles['pre-order-breakup']} valueClassName={styles['pre-order-breakup']}/>))}
								</div>)}
						</div>) : null}
				</div>
				{finalSavingsText && (<div className={styles['offers']}>
						<div className={styles['offers-text']}>{finalSavingsText}</div>
					</div>)}
				<PriceDescription priceDescription={priceDescription}/>
			</Tooltip>
		</div>);
}
